import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import { Box } from '@hub/box';
import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base';
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint';
import { LinkContext } from '../../../context';
import { transformNavigationClickedItemsData } from '../../../analytics-segment/events/navigation-item';
import { useAnalytics } from '../../../analytics';
import { MegaMenuNavItem } from './megamenu-nav-link';
import { MainNavItemWrapper } from './main-nav-item-wrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavLink = _ref => {
  let {
    item,
    index,
    openHamburgerMenuAtPath,
    megaMenuPortalRef,
    openId,
    setOpenId,
    closeMenuOnMouseLeave
  } = _ref;
  const attrsAllowList = ['target', 'rel', 'title'];
  const attrs = item.attrs;
  const Link = useContext(LinkContext); // check if mobile view

  const isMobile = useMobileBreakpoint();
  const isWide = useBreakpointValue([false, false, true], DEFAULT_BREAKPOINT);
  const analytics = useAnalytics();

  if (isWide && (item.megaMenuItems || item.simpleMenuItems)) {
    return /*#__PURE__*/_jsx(MegaMenuNavItem, {
      closeMenuOnMouseLeave: closeMenuOnMouseLeave,
      index: index,
      item: item,
      megaMenuPortalRef: megaMenuPortalRef,
      openId: openId,
      setOpenId: setOpenId,
      "data-id": "tabs_nav-link_NavLink_MegaMenuNavItem"
    });
  } else if (isMobile && item.hamburgerMenuTarget || !item.url && item.hamburgerMenuTarget) {
    return /*#__PURE__*/_jsx(MainNavItemWrapper, {
      isDisplayedHorizontally: true,
      "data-id": "tabs_nav-link_NavLink_MainNavItemWrapper",
      children: /*#__PURE__*/_jsx(Box, {
        as: "button",
        sx: {
          height: 'size-full'
        },
        onClick: () => openHamburgerMenuAtPath(item.hamburgerMenuTarget),
        "data-id": "tabs_nav-link_NavLink_MainNavItemWrapper_Box",
        children: item.label
      })
    });
  } else if (item.url) {
    return /*#__PURE__*/_jsx(MainNavItemWrapper, {
      isDisplayedHorizontally: true,
      sx: {
        _hover: {
          textDecoration: 'underline'
        }
      },
      "data-id": "tabs_nav-link_NavLink_MainNavItemWrapper",
      children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        as: props => /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
          onClick: () => {
            transformNavigationClickedItemsData(analytics, {
              parentLabel: item.label,
              link: item.url
            });
          },
          "data-id": "tabs_nav-link_NavLink_Link"
        })),
        to: item.url
      }, attrs && attrsAllowList.reduce((memo, key) => _objectSpread(_objectSpread({}, memo), {}, {
        [key]: attrs[key]
      }), {})), {}, {
        sx: {
          height: 'size-full',
          display: 'inline-flex',
          alignItems: 'center'
        },
        "data-id": "tabs_nav-link_NavLink_MainNavItemWrapper_Box",
        children: item.label
      }))
    });
  } // If no mega menu items, no hamburger targets, and no url... Don't
  // render anything


  return null;
};